module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_vm._v("\n  SETTINGS\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07a18fb5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/settings/components/Settings.vue
// module id = 2081
// module chunks = 1